<template>
    <div>
        <v-container grid-list-xs>
            <template>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn class="font-weight-light" tile color="black" dark  @click="btn_add"  >
                        <v-icon >add</v-icon>Customer
                    </v-btn>
                </v-toolbar>
            </template>
        </v-container>

        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.cust_code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">{{ props.item.address }}</td>
                <td class="text-xs-left">{{ props.item.tel }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left" >{{ props.item.credit }}</td>
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="add_credit(props.item.cust_code ,props.item.name )">add</v-icon>
                    <v-icon class="mr-2" @click="add_order(props.item.cust_code,props.item.name,props.item.credit)">add_shopping_cart</v-icon>
                    <v-icon class="mr-2" @click="edit_cust(props.item.cust_code)">edit</v-icon>
                    <v-icon class="mr-2" @click="view_order(props.item.cust_code,props.item.name)">view_list</v-icon>
                    <v-icon class="mr-2" @click="credit_cust(props.item.cust_code)">credit_card</v-icon>
                    <v-icon class="mr-2" @click="line_push(props.item.cust_code,props.item.name)">chat</v-icon>
                </td>

                </template>

            </v-data-table>

            <v-dialog v-model="dialog" max-width="290">
                <v-card>
                    <v-card-title class="headline">Add credit</v-card-title>
                        <v-container grid-list-xs>
                              <p>Code : {{current_cust_code}}</p>
                              <p>Name : {{current_cust_name}}</p>  
                              <v-text-field
                                    v-model="credit_point"
                                    :rules="[numberRule]"
                                    type = "number"
                                    label="Number of credit"
                                    required
                                ></v-text-field>     
                               <v-text-field
                                    v-model="expire_day"
                                    :rules="[numberRule]"
                                    type = "number"
                                    label="Age of expire (Day)"
                                    required
                                ></v-text-field>    
                                <v-text-field
                                    v-model="add_credit_note"
                                    type = "text"
                                    label="Note"
                                    required
                                ></v-text-field>                                  
                                    <v-layout align-center justify-center>
                                        <v-card-actions class="text-xs-center">
                                            <v-btn class="font-weight-light" tile color="black" dark   @click="add_credit_sync(current_cust_code)"
                                            >Confirm</v-btn>
                                        </v-card-actions>    
                                    </v-layout>    
                        </v-container>      

                </v-card>
            </v-dialog>


            <v-dialog v-model="dialog_c" max-width="290">
                <v-card>
                    <v-card-title class="headline">Line Chat</v-card-title>
                        <v-container grid-list-xs>
                              <p>Code : {{current_cust_code}}</p>
                              <p>Name : {{current_cust_name}}</p>  
                              <v-text-field
                                    v-model="line_msg"
                                    type = "text"
                                    label=""
                                ></v-text-field>                                    
                                    <v-layout align-center justify-center>
                                        <v-card-actions class="text-xs-center">
                                            <v-btn class="font-weight-light" tile color="black" dark   @click="send_chat_line_push(current_cust_code)"
                                            >Send Message</v-btn>
                                        </v-card-actions>    
                                    </v-layout>    
                        </v-container>      

                </v-card>
                </v-dialog>



        </v-container>

    </div>
</template>

<script>
import axios from "axios"
export default {

data() {
    return {
            /** กำหนด headers ให้ตรง */
            headers:[ 
              { text: 'Code', value: 'cust_code' },
              { text: 'Name', value: 'name' },
              { text: 'Address', value: 'address' },
              { text: 'Tel', value: 'tel' },
              { text: 'Email', value: 'email' },
              { text: 'Credit', value: 'Credit' },
              { text: 'Actions', value: 'actions', align: 'center', sortable: false },
            ],
            table_details:[],
            users: [],
            search: '',
            credit_point : 0 ,
            expire_day : 30 ,
            add_credit_note : "",
            current_credit : 0 ,
            current_cust_code : '',
            current_cust_name : '',
            line_id : '',
            line_msg : '',
            dialog: false ,
            dialog_c: false ,          
            url : "https://ws.plantifulbkk.shop/images/" ,
        }
    },
    created () {
      console.log("CREATE")
      this.read_data()
    },

    methods :{
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * 
            charactersLength));
            }
            return result;
        },
        read_data_1(){
            let table_arr = []
            axios.get("https://ws.plantifulbkk.shop/get_customer.php",{
                        params: {
                            
                        }
                    }).then(result=>{
                var result1 = result && result.data;
                this.users = result1;
                console.log(result1)
            })
        },
        read_data() {
            const vm = this;
            vm.axios.get('https://ws.plantifulbkk.shop/get_customer.php').then(response => {
            var result = JSON.parse(JSON.stringify(response.data))
            vm.users = result
            console.log(vm.users)
            });
        },
        edit_cust(item){
            this.$store.dispatch('set_user_ac_editer', '1'  )
            this.$store.dispatch('set_user_ac_code', item  )
            this.$router.push('/editcustomer')
        },
        credit_cust(item){
            this.$store.dispatch('set_user_ac_code', item  )
            this.$router.push('/creditlist2')
        },
        line_push(item, name){
            this.current_cust_code = item
            this.current_cust_name = name

                axios.get("https://ws.plantifulbkk.shop/get_line_user_id.php",{
                    params: {
                        scode: this.current_cust_code,
                    }
                }).then(result=>{
                        console.log(result.data)
                        
                        if (result.data == ""){
                            alert( "This user not connect line Member!" )
                        }else{
                            this.line_id = result.data
                            this.dialog_c = true
                        }
                        
                    })
                .catch(function (error) {
                        alert("Error")
                        console.log(error)
                    })
            
        },
        send_chat_line_push(){

                axios.get("https://api.plantifulbkk.shop/line_push_msg.php",{
                    params: {
                        id: this.line_id,
                        msg: this.line_msg ,
                    }
                }).then(result=>{

                        alert( " Sent successfully! " )

                    })
                .catch(function (error) {
                        alert("Error : " + JSON.stringify(result.data)  )
                    })
            this.line_msg = ""
            this.dialog_c = false
        },
        add_order(item, name,credit){
            if( credit == 0 ){
                alert(" Credit is not enough! ")
            }else{
                this.$store.dispatch('set_user_ac_code', item  )
                this.$store.dispatch('set_user_ac_name', name )
                this.$store.dispatch('set_point_ac', credit )
                this.$router.push('/add_order')
            }
        },
        add_credit(item, name){
            this.credit_point = 0
            this.dialog = true
            this.current_cust_code = item
            this.current_cust_name = name
        },
        view_order(item , name){
            this.$store.dispatch('set_user_ac_code', item  )
            this.$store.dispatch('set_user_ac_name', name )
            this.$router.push('/creditlist')
        },
        add_credit_sync(item){

            this.$store.dispatch('set_user_ac_code', item  )

            if ( this.credit_point !== "" && ( this.credit_point  % 1 == 0 ) )
            {

                axios.get("https://ws.plantifulbkk.shop/post_credit.php",{
                    params: {
                        scode: this.$store.getters.get_user_code ,
                        scredit: this.credit_point ,
                        sexp: this.expire_day ,
                        snote : this.add_credit_note,
                        tran_idi : this.makeid(20) ,
                    }
                }).then(result=>{
                        console.log(result.data)
                        alert("Add credit Already!")
                        this.read_data()
                    })
                .catch(function (error) {
                        alert("Error")
                        console.log(error)
                    })

                this.dialog = false    
            }else{
                alert("Invalid Number !!") 

            }
        },
        btn_add(){
            this.$store.dispatch('set_user_ac_editer', '0'  )
            this.$router.push('/addcustomer')
        },
    },
    

}


</script>

<style>
 
@import url('https://fonts.googleapis.com/css2?family=Mitr:wght@200&display=swap');

H2 {
  font-family: 'Mitr', sans-serif;
}

</style>


// WEBPACK FOOTER //
// src/pages/customer.vue